export default __webpack_public_path__ + "static/media/museums.6dc810d3.png";